var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{class:['tab-btn', _vm.isActive && 'tab-btn--active'],on:{"click":function($event){return _vm.scrollToSection(_vm.hash)}}},[_vm._t("default"),_vm._v(" "),(_vm.isMounted && _vm.hasCount)?_c('span',[_vm._v(_vm._s(_vm.count))]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }